import { noop } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import ImagePickerItem from 'entities/image_picker_item'
import ImageSource from 'entities/image_source'
import DefaultImageSelector from 'components/image_picker_default_image_selector'
import Uploader from 'components/image_picker_uploader'

/**
 * 描画されるコンポーネントは以下の3パターン
 *
 * 1. アップロードフォーム + デフォルト画像選択
 * 2. アップロード済みの画像 + 削除ボタン
 * 3. アップロードフォーム + デフォルト画像選択（どれか1つが選択状態）
 *
 * @returns {JSX}
 */

const imagePropTypes = {
  pickerItem: PropTypes.instanceOf(ImagePickerItem)
}

const imageDefaultProps = {
  pickerItem: new ImagePickerItem()
}

const ImageWrapper = ({ pickerItem, onLoadImage, onRemoveImage }) => {
  if (!pickerItem.url || pickerItem.isDefaultImage) {
    return null
  }

  return (
    <div className="form-group-uploader">
      <div className="upload-image">
        <img src={pickerItem.url} alt="" onLoad={onLoadImage} />
        <button type="button" className="btn btn-danger" onClick={onRemoveImage}>
          {I18n.t('components.image_picker.button.delete')}
        </button>
      </div>
    </div>
  )
}

ImageWrapper.propTypes = {
  ...imagePropTypes,
  onLoadImage: PropTypes.func,
  onRemoveImage: PropTypes.func
}

ImageWrapper.defaultProps = {
  ...imageDefaultProps,
  onLoadImage: noop,
  onRemoveImage: noop
}

const ImagePicker = ({ imageSources, order, pickerItem, onChangePickerItem, onLoadImage }) => {
  const handleRemoveImage = () => {
    const newPickerItem = new ImagePickerItem()
    onChangePickerItem(newPickerItem)
  }

  return (
    <div className="form-group">
      <ImageWrapper pickerItem={pickerItem} onLoadImage={onLoadImage} onRemoveImage={handleRemoveImage} />
      <Uploader pickerItem={pickerItem} onChangePickerItem={newPickerItem => onChangePickerItem(newPickerItem)} />
      <DefaultImageSelector
        imageSources={imageSources}
        order={order}
        pickerItem={pickerItem}
        onChangePickerItem={newPickerItem => onChangePickerItem(newPickerItem)}
      />
    </div>
  )
}

ImagePicker.propTypes = {
  ...imagePropTypes,
  imageSources: PropTypes.arrayOf(PropTypes.instanceOf(ImageSource)).isRequired,
  order: PropTypes.number,
  onChangePickerItem: PropTypes.func
}

ImagePicker.defaultProps = {
  ...imageDefaultProps,
  order: null,
  onChangePickerItem: noop,
  onLoadImage: noop
}

export default ImagePicker
